// File preview card — mirrors app/upload.py::_file_preview_card: a LOADED/FAILED
// badge, the filename, and the resolved sheet / row count / mode.
interface Props {
  filename: string;
  loaded: boolean;
  sheet?: string;
  mode?: string;
  rows?: number;
  error?: string;
}

export default function FilePreviewCard({ filename, loaded, sheet, mode, rows, error }: Props) {
  return (
    <div className="preview">
      <div className="preview-head">
        <span className={`badge ${loaded ? "badge-success" : "badge-risk"}`}>
          {loaded ? "LOADED" : "FAILED"}
        </span>
        <span className="text-dark">{filename}</span>
      </div>
      <div className="preview-body">
        {error ? (
          <span className="text-risk">{error}</span>
        ) : (
          <>
            {sheet && <>Sheet: <strong>{sheet}</strong>&nbsp;·&nbsp;</>}
            {rows !== undefined && <>Rows: <strong>{rows.toLocaleString()}</strong>&nbsp;·&nbsp;</>}
            {mode && <>Basis: <strong>{mode}</strong></>}
          </>
        )}
      </div>
    </div>
  );
}
